export class CardModel {
  CardDefinitions: CardDefinition[];
  VisibilityMode: string;
  Actions: CardAction[];
  constructor(cardDefinition: CardDefinition[]) {
    this.CardDefinitions = cardDefinition;
  }
}

export interface CardDefinition {
  Icon?: string;
  DisplayText: string;
  SecondaryDisplayText?: string;
  Picture?: string;
  Description?: string;
  PrimaryAction?: CardAction;
  SecondaryAction?: CardAction;
  ThirdAction?: CardAction;
  FourthAction?: CardAction;
  OtherActions?: CardAction[];
  CardDefinitions?: CardDefinition[];
  Template?: TemplateEnum;
  Order: Order;
  DataObject: any;
  IsVisible?(str: string): boolean;
}

export enum VisibilityMode {
  Default = 'Default',
  Full = 'Full',
}

export class Order {
  Number: number;
  DisplayText: string;
  VisibilityMode: VisibilityMode;
  LeftIconPath: string;
  constructor(number: number, displayText: string, visibilityMode: VisibilityMode, leftIconPath?: string) {
    this.Number = number;
    this.DisplayText = displayText;
    this.VisibilityMode = visibilityMode;
    this.LeftIconPath = leftIconPath;
  }
}

export enum TemplateEnum {
  Large,
  Medium,
  Small,
}

export class CardAction {
  DisplayText: string;
  Icon?: string;
  Action: Function;
  constructor(displayText: string, action: Function, icon?: string) {
    this.DisplayText = displayText;
    this.Action = action;
    this.Icon = icon;
  }
}
